import React, { ChangeEventHandler } from 'react';
import useMd from '@web/ui/components/generic/hooks/useMd';
import { CustomSignupField } from '@shared/welibrary-graphql/types';

interface DescriptionProps {
    name: string;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
    field: CustomSignupField & { translatedOptions: CustomSignupField['options'] };
    value?: string;
    maxLength?: number;
    showPrompt?: boolean;
}

const Description: React.FC<DescriptionProps> = ({
    name,
    field: { prompt, required },
    value = '',
    onChange,
    maxLength = 1000,
}) => {
    const md = useMd();
    return (
        <div className="custom-signup-item my-[20px]">
            <div className="custom-signup-label">
                <div
                    className="custom-signup-description"
                    dangerouslySetInnerHTML={{ __html: md.render(prompt) }}
                />
            </div>

            {/* <textarea
                value={value}
                onChange={onChange}
                id={name}
                name={name}
                key={name}
                placeholder={'Write your answer here' ?? ''}
                maxLength={maxLength}
                className={'optimize-text-field w-input'}
            /> */}
        </div>
    );
};

export default Description;
